/**
 * StepTherapySection - Output section for step therapy info (Drug only)
 *
 * Displays step therapy requirements and medications.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface StepTherapySectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const StepTherapySection: React.FC<StepTherapySectionProps> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Step Therapy</span>
          <SectionTriggerScore subsectionKey="step_therapy" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.step_therapy">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Step Therapy Required"
              value={data?.step_therapy_required}
              fieldId="step_therapy_required"
            />
            <Field label="Method" value={data?.step_therapy_method} fieldId="step_therapy_method" />
            <Field
              label="Available Date"
              value={data?.step_therapy_available_date}
              fieldId="step_therapy_available_date"
            />
            <Field
              label="Session Start Date"
              value={data?.step_therapy_session_start_date}
              fieldId="step_therapy_session_start_date"
            />
            <div className="col-span-2">
              <Field
                label="Treatments Required"
                value={data?.step_therapy_treatments_required}
                fieldId="step_therapy_treatments_required"
              />
            </div>
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
